import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'picturefill';
import 'picturefill/dist/plugins/mutation/pf.mutation.min';
import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import smoothscroll from 'smoothscroll-polyfill';
import HondaApp from 'apps/HondaApp';
import './theme/fonts/font-definition.css';
smoothscroll.polyfill();

ReactDOM.render(
  <React.StrictMode>
    <HondaApp />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
